import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Events = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Events</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Events</li>
          </ul>
        </div>
      </section>

      <section className="ul-section-spacing">
        <div className="ul-container">

          <div className="ul-events-wrapper">
            <div className="row ul-bs-row row-cols-lg-2 row-cols-1">

              <div className="col wow animate__fadeInUp">
                <div className="ul-event ul-event--inner">
                  <div className="ul-event-img">
                    <img
                      src="/assets/new-img/new/volunteers-planting-trees-in-the-park-2025-09-06-19-31-12-utc.jpg"
                      alt="Event Image"
                    />
                    <span className="date">29 <span>July</span></span>
                  </div>
                  <div className="ul-event-txt">
                    <h3 className="ul-event-title">
                      <Link to="/donations"
                        >Community Health Literacy Workshop - Diabetes Basics</Link
                      >
                    </h3>
                    <p className="ul-event-descr">
                      Join us for a bilingual workshop covering diabetes
                      prevention, management, and local resources. Open to all
                      community members.
                    </p>
                    <div className="ul-event-info">
                      <span className="ul-event-info-title">Venue</span>
                      <p className="ul-event-info-descr">
                        Community Center, Brooklyn, NY
                      </p>
                    </div>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Event Details</Link
                    >
                  </div>
                </div>
              </div>

              <div className="col wow animate__fadeInUp">
                <div className="ul-event ul-event--inner">
                  <div className="ul-event-img">
                    <img
                      src="/assets/new-img/new/plant-support-and-community-people-in-park-natur-2025-04-06-09-50-44-utc.jpg"
                      alt="Event Image"
                    />
                    <span className="date">29 <span>July</span></span>
                  </div>
                  <div className="ul-event-txt">
                    <h3 className="ul-event-title">
                      <Link to="/donations"
                        >Community Health Literacy Workshop - Diabetes Basics</Link
                      >
                    </h3>
                    <p className="ul-event-descr">
                      Join us for a bilingual workshop covering diabetes
                      prevention, management, and local resources. Open to all
                      community members.
                    </p>
                    <div className="ul-event-info">
                      <span className="ul-event-info-title">Venue</span>
                      <p className="ul-event-info-descr">
                        Community Center, Brooklyn, NY
                      </p>
                    </div>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Event Details</Link
                    >
                  </div>
                </div>
              </div>

              <div className="col wow animate__fadeInUp">
                <div className="ul-event ul-event--inner">
                  <div className="ul-event-img">
                    <img
                      src="/assets/new-img/new/people-donating-clothing-to-charity-collection-in-2024-10-21-08-45-33-utc.jpg"
                      alt="Event Image"
                    />
                    <span className="date">29 <span>July</span></span>
                  </div>
                  <div className="ul-event-txt">
                    <h3 className="ul-event-title">
                      <Link to="/donations"
                        >Community Health Literacy Workshop - Diabetes Basics</Link
                      >
                    </h3>
                    <p className="ul-event-descr">
                      Join us for a bilingual workshop covering diabetes
                      prevention, management, and local resources. Open to all
                      community members.
                    </p>
                    <div className="ul-event-info">
                      <span className="ul-event-info-title">Venue</span>
                      <p className="ul-event-info-descr">
                        Community Center, Brooklyn, NY
                      </p>
                    </div>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Event Details</Link
                    >
                  </div>
                </div>
              </div>

              <div className="col wow animate__fadeInUp">
                <div className="ul-event ul-event--inner">
                  <div className="ul-event-img">
                    <img
                      src="/assets/new-img/new/group-of-volunteers-sorting-garbage-2025-04-02-09-20-13-utc.JPG"
                      alt="Event Image"
                    />
                    <span className="date">29 <span>July</span></span>
                  </div>
                  <div className="ul-event-txt">
                    <h3 className="ul-event-title">
                      <Link to="/donations"
                        >Community Health Literacy Workshop - Diabetes Basics</Link
                      >
                    </h3>
                    <p className="ul-event-descr">
                      Join us for a bilingual workshop covering diabetes
                      prevention, management, and local resources. Open to all
                      community members.
                    </p>
                    <div className="ul-event-info">
                      <span className="ul-event-info-title">Venue</span>
                      <p className="ul-event-info-descr">
                        Community Center, Brooklyn, NY
                      </p>
                    </div>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Event Details</Link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ul-pagination">
          <ul>
            <li>
              <button type="button" className="pagination-prev" aria-label="Previous"><i className="flaticon-back"></i></button>
            </li>
            <li className="pages" role="navigation" aria-label="Pagination">
              <button type="button" className="active">1</button>
              <button type="button">2</button>
              <button type="button">3</button>
            </li>
            <li>
              <button type="button" className="pagination-next" aria-label="Next"><i className="flaticon-next"></i></button>
            </li>
          </ul>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Events;
